import { createTheme } from '@mui/material/styles';
import { breakpoints } from './breakpoints';
import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { shadows } from './shadows';
import { shape } from './shape';
import { transitions } from './transitions';
import { zIndex } from './zIndex';

/**
 * Create a theme instance with mobile-first approach
 * @param {boolean} darkMode - Whether to use dark mode
 * @returns {Theme} MUI theme object
 */
export const createAppTheme = (darkMode = false) => {
  return createTheme({
    palette: palette(darkMode),
    typography,
    breakpoints,
    components: components(darkMode),
    shadows: shadows(darkMode),
    shape,
    transitions,
    zIndex,
  });
};

export default createAppTheme;